// extracted by mini-css-extract-plugin
module.exports = {"icon":"navTrigger_icon__pnRsy w-[28px] h-[28px] bg-no-repeat bg-contain","contactIcon":"navTrigger_contactIcon__ij4t_ inline-block w-[20px] h-[20px] bg-no-repeat bg-contain"};